export const isValidMobile = (mobileNo) => {
  const mobileRegex = /^[0-9]{10}$/;
  return mobileRegex.test(mobileNo);
};
